/*------------------------------------*\
    SCROLLER
\*------------------------------------*/
class Scroller {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        let target = document.getElementById(self.elem.getAttribute('data-target'));
        let scroller = self.elem.querySelector('.js-scroller-bar');

        target.addEventListener('scroll', evt => {
            let scrollPercentage = 100 * target.scrollLeft / (target.scrollWidth - target.clientWidth);
            scroller.style.left = `${scrollPercentage / 4}px`;
        });
    }
}

export default Scroller;
